import React, { useState } from 'react';
import { ChevronLeft, Mail, Bug } from 'lucide-react';
import { Button } from '../components/Button';
interface ResetEmailSentProps {
  onBack: () => void;
  onResend: () => void;
}
export function ResetEmailSent({
  onBack,
  onResend
}: ResetEmailSentProps) {
  const [showDebug, setShowDebug] = useState(false);
  return <div className="flex flex-col h-full w-full bg-stone-50 overflow-y-auto relative" data-id="element-1040">
      {/* Debug Toggle */}
      <button onClick={() => setShowDebug(!showDebug)} className="absolute top-8 right-2 z-40 w-7 h-7 rounded-full bg-slate-800/70 text-white flex items-center justify-center hover:bg-slate-800 transition-colors" title="Debug panel" data-id="element-1041">
        <Bug size={14} data-id="element-1042" />
      </button>

      {/* Debug Panel */}
      {showDebug && <div className="absolute top-16 right-2 z-40 bg-slate-800 text-white rounded-2xl p-3 shadow-xl w-64 text-xs animate-in fade-in zoom-in-95 duration-150" data-id="element-1043">
          <p className="font-bold text-slate-400 uppercase tracking-wider text-[10px] mb-2" data-id="element-1044">
            Debug Panel
          </p>
          <button onClick={() => {
        setShowDebug(false);
        onCreateNewPassword?.();
      }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1045">
            ▶ Create New Password screen
          </button>
          <button onClick={() => {
        setShowDebug(false);
        onLinkExpired?.();
      }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium mb-1" data-id="element-1046">
            ▶ Link Expired state
          </button>
          <button onClick={() => {
        setShowDebug(false);
        onResetSuccess?.();
      }} className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-slate-700 transition-colors font-medium" data-id="element-1047">
            ▶ Password Reset Success
          </button>
        </div>}

      {/* Header */}
      <div className="flex items-center justify-between p-6 pt-8 sticky top-0 bg-stone-50/90 backdrop-blur-md z-20" data-id="element-1048">
        <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-slate-200/50 text-slate-600 transition-colors" aria-label="Go back" data-id="element-1049">
          <ChevronLeft size={28} data-id="element-1050" />
        </button>
        <div className="w-12 h-12 rounded-2xl overflow-hidden border-2 border-white shadow-sm bg-stone-200" data-id="element-1051">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-1052" />
        </div>
        <div className="w-10" data-id="element-1053" />
      </div>

      <div className="px-6 pb-8 flex-1 flex flex-col items-center justify-center" data-id="element-1054">
        {/* Icon */}
        <div className="w-20 h-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-6" data-id="element-1055">
          <Mail size={40} data-id="element-1056" />
        </div>

        {/* Content */}
        <div className="text-center mb-8 max-w-sm" data-id="element-1057">
          <h1 className="text-2xl font-extrabold text-slate-800 mb-3" data-id="element-1058">
            Check your email
          </h1>
          <p className="text-slate-600 font-medium leading-relaxed mb-4" data-id="element-1059">
            If an account exists for this email, we've sent a password reset
            link. Please check your inbox.
          </p>
          <p className="text-sm text-slate-500 font-medium" data-id="element-1060">
            Check your spam or junk folder if you don't see the email.
          </p>
        </div>

        {/* Actions */}
        <div className="w-full max-w-sm space-y-4" data-id="element-1061">
          <Button type="button" variant="primary" fullWidth onClick={onResend} data-id="element-1062">
            Resend link
          </Button>

          <button type="button" onClick={onBack} className="w-full text-center text-sm font-bold text-slate-600 hover:text-slate-800 py-2" data-id="element-1063">
            Back to Login
          </button>
        </div>
      </div>
    </div>;
}